var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.checkActionPerm("update_discount") &&
    _vm.servcOrder.workAssignStateX == _vm.allWorkAssignStateX &&
    !_vm.servcOrder.servcAmountFixed &&
    !_vm.userIsShopFlag
      ? _c("div", { staticClass: "btn-row" }, [
          _c("div", { staticClass: "fr" }, [
            !_vm.showUpdateDiscount && !_vm.servcOrder.cancelled
              ? _c(
                  "div",
                  {
                    staticClass: "swb-btn swb-btn-small",
                    on: {
                      click: function($event) {
                        _vm.showUpdateDiscount = true
                      }
                    }
                  },
                  [_vm._v("改价")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showUpdateDiscount
              ? _c(
                  "div",
                  {
                    staticClass: "swb-btn swb-btn-small",
                    on: { click: _vm.saveChangePrice }
                  },
                  [_vm._v("保存改价")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showUpdateDiscount
              ? _c(
                  "div",
                  {
                    staticClass: "swb-btn swb-btn-small",
                    on: { click: _vm.cancelPrice }
                  },
                  [_vm._v("取消改价")]
                )
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "order-detail-panel" }, [
      _c("div", { staticClass: "trade-status" }, [
        _c("table", { staticClass: "trade-status-table" }, [
          _c("tbody", [
            _c("tr", [
              _c("td", { staticClass: "trade-imfor table-td" }, [
                _c("div", { staticClass: "info-block" }, [
                  _c("ul", { staticClass: "pb15" }, [
                    _c("li", { staticClass: "table-list" }, [
                      _c("div", { staticClass: "trade-imfor-dt" }, [
                        _vm._v("订单编号")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "trade-imfor-dd" }, [
                        _vm._v(_vm._s(_vm.servcOrder.no))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "table-list" }, [
                      _c("div", { staticClass: "trade-imfor-dt" }, [
                        _vm._v("买家")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "trade-imfor-dd" }, [
                        _vm._v(_vm._s(_vm.servcOrder.buyerName))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "table-list" }, [
                      _c("div", { staticClass: "trade-imfor-dt" }, [
                        _vm._v("买家业务单元")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "trade-imfor-dd" }, [
                        _vm._v(_vm._s(_vm.servcOrder.buyerShopName))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "table-list" }, [
                      _c("div", { staticClass: "trade-imfor-dt" }, [
                        _vm._v("买家业务部门")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "trade-imfor-dd" }, [
                        _vm._v(_vm._s(_vm.servcOrder.buyerBizUnitName))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "table-list" }, [
                      _c("div", { staticClass: "trade-imfor-dt" }, [
                        _vm._v("服务预约时间")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "trade-imfor-dd" }, [
                        _vm._v(_vm._s(_vm.servcOrder.planTime))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "table-list" }, [
                      _c("div", { staticClass: "trade-imfor-dt" }, [
                        _vm._v("收货地址")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "trade-imfor-dd" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.servcOrder.buyerShopAddr) +
                              "，" +
                              _vm._s(_vm.servcOrder.buyerShopContactTel)
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "table-list" }, [
                      _c("div", { staticClass: "trade-imfor-dt" }, [
                        _vm._v("故障描述")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "trade-imfor-dd" }, [
                        _vm._v(_vm._s(_vm.servcOrder.troubleDesc))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "table-list" }, [
                      _c("div", { staticClass: "trade-imfor-dt" }, [
                        _vm._v("买家留言")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "trade-imfor-dd" }, [
                        _vm._v(_vm._s(_vm.servcOrder.postscript))
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "trade-detail table-td" }, [
                _c("div", { staticClass: "info-block" }, [
                  _c("ul", { staticClass: "pb15" }, [
                    _c("li", { staticClass: "table-list" }, [
                      _c("div", { staticClass: "trade-imfor-dt" }, [
                        _vm._v("订单状态:")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "trade-imfor-dd",
                          staticStyle: { width: "auto" }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.servcOrder.state))])]
                      ),
                      _vm._v(" "),
                      _vm.servcOrder.cancelled
                        ? _c("div", [
                            _c("div", { staticClass: "trade-imfor-dt" }, [
                              _vm._v("取消原因:")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "trade-imfor-dd",
                                staticStyle: { width: "auto" }
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.servcOrder.cancelCause))
                                ])
                              ]
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "orders-list-container mt20" }, [
      _c(
        "table",
        { staticClass: "orders-list-panel1" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._l(_vm.servcOrder.itemList, function(servcOrderItem) {
            return _c("tbody", { staticClass: "orders-body" }, [
              _vm._m(2, true),
              _vm._v(" "),
              _c("tr", { staticClass: "info-row" }, [
                _c("td", [
                  _c("div", { staticClass: "goods-info-block" }, [
                    _c("div", { staticClass: "goods-item clearfix" }, [
                      _c("div", { staticClass: "good-img" }, [
                        _c("img", {
                          attrs: { src: servcOrderItem.servcFileBrowseUrl }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "good-msg" }, [
                        _c("p", { staticClass: "ellipsis-2 font12" }, [
                          _vm._v(_vm._s(servcOrderItem.title))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clr" })
                  ])
                ]),
                _vm._v(" "),
                _c("td", [
                  !_vm.userIsShopFlag
                    ? _c("div", { staticClass: "align-right" }, [
                        _vm._v("\n                        ¥"),
                        _c("b", { staticClass: "price" }, [
                          _vm._v(
                            _vm._s(
                              parseFloat(servcOrderItem.toDoorFee).toFixed(2)
                            )
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("td", [
                  !_vm.userIsShopFlag && servcOrderItem.generallFee != null
                    ? _c("div", { staticClass: "align-right" }, [
                        _c("span", [
                          _vm._v("¥"),
                          _c("b", { staticClass: "price" }, [
                            _vm._v(
                              _vm._s(
                                parseFloat(servcOrderItem.generallFee).toFixed(
                                  2
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    : !_vm.userIsShopFlag
                    ? _c("div", { staticClass: "align-right" }, [
                        _vm._v("¥"),
                        _c("b", { staticClass: "price" }, [_vm._v("0.00")])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("td", [
                  !_vm.userIsShopFlag && servcOrderItem.accFee != null
                    ? _c("div", { staticClass: "align-right" }, [
                        _c("span", [
                          _vm._v("¥"),
                          _c("b", { staticClass: "price" }, [
                            _vm._v(
                              _vm._s(
                                parseFloat(servcOrderItem.accFee).toFixed(2)
                              )
                            )
                          ])
                        ])
                      ])
                    : !_vm.userIsShopFlag
                    ? _c("div", { staticClass: "align-right" }, [
                        _vm._v("¥"),
                        _c("b", { staticClass: "price" }, [_vm._v("0.00")])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-right" }, [
                  _c("b", { staticClass: "pri" }, [
                    _vm._v(_vm._s(servcOrderItem.yqRspTimeMi || 0))
                  ])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-right" }, [
                  _c("b", { staticClass: "pri" }, [
                    _vm._v(_vm._s(servcOrderItem.yqArriveTimeMi || 0))
                  ])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-right" }, [
                  _c("b", { staticClass: "pri" }, [
                    _vm._v(_vm._s(servcOrderItem.yqRepairedTimeMi || 0))
                  ])
                ]),
                _vm._v(" "),
                _c("td", [
                  !_vm.userIsShopFlag
                    ? _c("div", [
                        servcOrderItem.discount != null &&
                        !_vm.showUpdateDiscount
                          ? _c("div", { staticClass: "align-right" }, [
                              _c("span", [
                                _vm._v("¥"),
                                _c("b", { staticClass: "price" }, [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        servcOrderItem.discount || 0.0
                                      ).toFixed(2)
                                    )
                                  )
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showUpdateDiscount
                          ? _c("div", [
                              _c("span", [
                                _vm._v("¥"),
                                _c(
                                  "b",
                                  { staticClass: "price align-right" },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        type: "number",
                                        controls: false,
                                        min: 0,
                                        max: servcOrderItem.totalDiscount
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.changeExtraDistCount(
                                            servcOrderItem.id
                                          )
                                        }
                                      },
                                      model: {
                                        value: servcOrderItem.discount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            servcOrderItem,
                                            "discount",
                                            $$v
                                          )
                                        },
                                        expression: "servcOrderItem.discount"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "introduce-box fr" }, [
                          _c("div", { staticClass: "caption" }, [
                            _vm._v("价格说明")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "content" }, [
                            _vm._v(_vm._s(servcOrderItem.feeDesc))
                          ])
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("td", [
                  !_vm.userIsShopFlag
                    ? _c(
                        "div",
                        {
                          staticClass: "align-right",
                          staticStyle: { width: "inherit" }
                        },
                        [
                          _c("span", [
                            _vm._v("¥"),
                            _c("b", { staticClass: "price" }, [
                              _vm._v(
                                _vm._s(
                                  (
                                    parseInt(servcOrderItem.toDoorFee || 0) +
                                    parseInt(servcOrderItem.workFee || 0) +
                                    parseInt(servcOrderItem.accFee || 0) +
                                    parseInt(servcOrderItem.generallFee || 0)
                                  ).toFixed(2)
                                )
                              )
                            ])
                          ])
                        ]
                      )
                    : !_vm.userIsShopFlag
                    ? _c("div", {}, [
                        _vm._v("¥"),
                        _c("b", { staticClass: "price" }, [_vm._v("0.00")])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-right" }, [
                  !_vm.userIsShopFlag
                    ? _c("span", {}, [
                        _vm._v("¥"),
                        _c("b", { staticClass: "price" }, [
                          _vm._v(
                            _vm._s(parseFloat(servcOrderItem.amount).toFixed(2))
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm.checkActionPerm("apply_after_sale") &&
                  _vm.servcOrder.svcNo == null &&
                  servcOrderItem.finished &&
                  servcOrderItem.wrntDueTime != null &&
                  servcOrderItem.wrntDueTime.format("yyyy-MM-dd") >=
                    _vm.curDate.format("yyyy-MM-dd")
                    ? _c(
                        "a",
                        {
                          staticClass: "font14 swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.doSaleServc(
                                servcOrderItem.orderId,
                                servcOrderItem.id
                              )
                            }
                          }
                        },
                        [_vm._v("申请售后")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkActionPerm("create_order_by_proxy") &&
                  _vm.servcOrder.svcNo == null &&
                  servcOrderItem.finished &&
                  servcOrderItem.wrntDueTime != null &&
                  servcOrderItem.wrntDueTime.format("yyyy-MM-dd") <
                    _vm.curDate.format("yyyy-MM-dd")
                    ? _c(
                        "a",
                        {
                          staticClass: "font14 swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.agencyOrder(
                                servcOrderItem.orderId,
                                servcOrderItem.ssuId
                              )
                            }
                          }
                        },
                        [_vm._v("代理下单")]
                      )
                    : _vm._e()
                ])
              ])
            ])
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "order-amount mt10" }, [
      _c("div", { staticClass: "total-amount-panel" }, [
        _c("table", {}, [
          _c("tbody", [
            !_vm.userIsShopFlag
              ? _c("tr", [
                  _c("td", { staticClass: "total-count" }, [
                    _c("div", { staticClass: "total-count-wrapper" }, [
                      _c("div", { staticClass: "total-count-line" }, [
                        _c(
                          "span",
                          {
                            staticClass: "label",
                            staticStyle: { "margin-right": "10px" }
                          },
                          [_vm._v("协议价：")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "inline-block align-left",
                            staticStyle: { width: "120px" }
                          },
                          [
                            _vm.servcOrder.totalAmount != null
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "font14 font-bold font-black"
                                  },
                                  [
                                    _vm._v(
                                      "¥ " +
                                        _vm._s(
                                          _vm.servcOrder.totalAmount.toFixed(2)
                                        )
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "font14 font-bold font-black"
                                  },
                                  [_vm._v("¥ 0.00")]
                                )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "total-count-line" }, [
                        _c(
                          "span",
                          {
                            staticClass: "label",
                            staticStyle: { "margin-right": "10px" }
                          },
                          [_vm._v("总优惠：")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "inline-block align-left",
                            staticStyle: { width: "120px" }
                          },
                          [
                            _vm.servcOrder.totalDiscount != null
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "font14 font-bold font-black"
                                  },
                                  [
                                    _vm._v(
                                      "¥ " +
                                        _vm._s(
                                          _vm.servcOrder.totalDiscount.toFixed(
                                            2
                                          )
                                        )
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "font14 font-bold font-black"
                                  },
                                  [_vm._v("¥ 0.00")]
                                )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "total-count-line" }, [
                        _c(
                          "span",
                          {
                            staticClass: "label",
                            staticStyle: { "margin-right": "10px" }
                          },
                          [_vm._v("结算价：")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "inline-block align-left",
                            staticStyle: { width: "120px" }
                          },
                          [
                            _vm.servcOrder.amount != null
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "font14 font-bold font-black"
                                  },
                                  [
                                    _vm._v(
                                      "¥ " +
                                        _vm._s(_vm.servcOrder.amount.toFixed(2))
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "font14 font-bold font-black"
                                  },
                                  [_vm._v("¥ 0.00")]
                                )
                          ]
                        )
                      ])
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "300px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "135px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "135px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "135px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "135px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "135px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "135px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "135px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "160px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "160px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "200px" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "orders-header" }, [
      _c("tr", {}, [
        _c("th", [_vm._v("服务")]),
        _vm._v(" "),
        _c("th", [_vm._v("上门费")]),
        _vm._v(" "),
        _c("th", [_vm._v("服务费")]),
        _vm._v(" "),
        _c("th", [_vm._v("配件费")]),
        _vm._v(" "),
        _c("th", [_vm._v("响应时长(分钟)")]),
        _vm._v(" "),
        _c("th", [_vm._v("到达时长(分钟)")]),
        _vm._v(" "),
        _c("th", [_vm._v("完成时长(分钟)")]),
        _vm._v(" "),
        _c("th", [_vm._v("优惠金额(元)")]),
        _vm._v(" "),
        _c("th", [_vm._v("协议价(元)")]),
        _vm._v(" "),
        _c("th", [_vm._v("结算价(元)")]),
        _vm._v(" "),
        _c("th", [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "blank-row" }, [
      _c("td", { attrs: { colspan: "8" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e87b430", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e87b430","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servcOrder/ServcOrderDetails.vue
// module id = 2041
// module chunks = 1